var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('your-skin-section-template',_vm._b({attrs:{"id":"your-skin","scores":_vm.scores}},'your-skin-section-template',_vm.patientSkinData,false))}
var staticRenderFns = []

export { render, staticRenderFns }